import { render, staticRenderFns } from "./SurfaceSlider.vue?vue&type=template&id=2597b293&scoped=true"
import script from "./SurfaceSlider.vue?vue&type=script&lang=ts"
export * from "./SurfaceSlider.vue?vue&type=script&lang=ts"
import style0 from "./SurfaceSlider.vue?vue&type=style&index=0&id=2597b293&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2597b293",
  null
  
)

export default component.exports